function createBangleJSUiCode(name, width, height, color, p1, p2, p3, z, renderBox, clickable, hitBoxType, hitBoxOffset, vibrate) {
  const uiCodeObject = {
    active: true,
    name,
    width,
    height,
    color,
    z,
    p1x: p1.x,
    p1y: p1.y,
    p2x: p2.x,
    p2y: p2.y,
    p3x: p3.x,
    p3y: p3.y,
    renderBoxTlX: renderBox.tl.x,
    renderBoxTlY: renderBox.tl.y,
    renderBoxBrX: renderBox.br.x,
    renderBoxBrY: renderBox.br.y,
    hitBoxOffsetXLeft: hitBoxOffset.hitBoxOffsetXLeft,
    hitBoxOffsetXRight: hitBoxOffset.hitBoxOffsetXRight,
    hitBoxOffsetYTop: hitBoxOffset.hitBoxOffsetYTop,
    hitBoxOffsetYBottom: hitBoxOffset.hitBoxOffsetYBottom,
    vibrate,
    render: function () {
      if (!this.active) return;
      g.setColor(this.color);
      g.fillPoly([this.p1x, this.p1y, this.p2x, this.p2y, this.p3x, this.p3y]);

    },
  }
  if (clickable) {
    addTouchHandling(uiCodeObject, hitBoxType);
  }
  return uiCodeObject;
}

function addTouchHandling(uiCodeObject, hitBoxType) {
  let tapped = false;
  if (hitBoxType === 'TRIANGLE') {
    uiCodeObject.wasTouched = function (e) {
      if (!this.active) return;

      function sign(p1, p2, p3) {
        return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
      }

      function pointInTriangle(pt, v1, v2, v3) {
        let d1, d2, d3;
        let has_neg, has_pos;

        d1 = sign(pt, v1, v2);
        d2 = sign(pt, v2, v3);
        d3 = sign(pt, v3, v1);

        has_neg = (d1 < 0) || (d2 < 0) || (d3 < 0);
        has_pos = (d1 > 0) || (d2 > 0) || (d3 > 0);

        return !(has_neg && has_pos);
      }

      return pointInTriangle(e, {x: this.p1x, y: this.p1y}, {x: this.p2x, y: this.p2y}, {x: this.p3x, y: this.p3y});
    };
    uiCodeObject.onScreenTouch = function (e) {
      if (tapped && this.vibrate) {
        Bangle.buzz(100, 0.2);
      }
    }
  }

  if (hitBoxType === 'RECTANGLE') {
    uiCodeObject.wasTouched = function (e) {
      if (!this.active) return;

      let tl = {x: this.p1x, y: this.p1y};
      let br = {x: this.p1x, y: this.p1y};

      tl.x = this.p2x < tl.x ? this.p2x : tl.x;
      tl.x = this.p3x < tl.x ? this.p3x : tl.x;

      tl.y = this.p2y < tl.y ? this.p2y : tl.y;
      tl.y = this.p3y < tl.y ? this.p3y : tl.y;

      br.x = this.p2x > br.x ? this.p2x : br.x;
      br.x = this.p3x > br.x ? this.p3x : br.x;

      br.y = this.p2y > br.y ? this.p2y : br.y;
      br.y = this.p3y > br.y ? this.p3y : br.y;
      tl.x -= this.hitBoxOffsetXLeft;
      tl.y -= this.hitBoxOffsetYTop;
      br.x += this.hitBoxOffsetXRight;
      br.y += this.hitBoxOffsetYBottom;

      return e.x >= tl.x && e.x <= br.x && e.y >= tl.y && e.y <= br.y;
    };
    uiCodeObject.onScreenTouch = function (e) {
      if (tapped && this.vibrate) {
        Bangle.buzz(100, 0.2);
      }
    }
  }
  return uiCodeObject;
}

module.exports = {
  createBangleJSUiCode,
}
